import {User, type UserData} from "@/types/users/user";
import {Contact} from "@/types/contacts/contact";

export class CompanyNote {
    public id: number | null;
    public category_id: number|null ;
    public company_id: number|null ;
    public title: string |null;
    public type_of_note: string |null;
    public description: string;
    public createdAt: Date|null;
    public updatedAt: Date|null;
    public created_by_user_id:number |null;
    public updated_by_user_id :number |null;
    public creatingUser: User;
    public updatingUser: User;
    public contacts: Contact[] | undefined;

    constructor(data: CompanyNoteData | void) {
        if (data === undefined) {
            this.id = null;
            this.category_id = null;
            this.company_id = null;
            this.title = "";
            this.type_of_note = "company-notes";
            this.description = "";
            this.createdAt = null;
            this.updatedAt = null;
            this.created_by_user_id = null;
            this.updated_by_user_id = null;
            this.creatingUser = new User();
            this.updatingUser = new User();
            this.contacts = [];

        } else {
            this.id = data.id;
            this.category_id = data.category_id;
            this.company_id = data.company_id;
            this.title = data.title;
            this.type_of_note = "company-notes";
            this.description = data.description;
            this.createdAt = data.createdAt;
            this.updatedAt = data.updatedAt;
            this.created_by_user_id = data.created_by_user_id;
            this.updated_by_user_id = data.updated_by_user_id;
            this.creatingUser = new User();
            this.updatingUser = new User();
            if(data.creatingUser!==null){
                this.creatingUser = new User(data.creatingUser);

            }
            if(data.updatingUser!==null) {
                this.updatingUser = new User(data.updatingUser);
            }
            this.contacts = [];
            if (data.contacts !== undefined) {
                data.contacts.forEach(contact => this.contacts.push((new Contact(contact))));
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.category_id = null;
        this.company_id = null;
        this.title = "";
        this.type_of_note = "company-notes";
        this.description = "";
        this.createdAt = null;
        this.updatedAt = null;
        this.created_by_user_id = null;
        this.updated_by_user_id = null;
        this.creatingUser = new User();
        this.updatingUser = new User();
        this.contacts = [];
    }
    serializeData():CompanyNoteData {
        return {
            id: this.id,
            category_id: this.category_id,
            company_id: this.company_id,
            title: this.title,
            description: this.description,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            created_by_user_id: this.created_by_user_id,
            updated_by_user_id: this.updated_by_user_id,
            creatingUser: this.creatingUser,
            updatingUser: this.updatingUser,
            // this.contacts.forEach(contact => compa.contacts?.push(contact.serializeData()));


        }
    }
}

export type CompanyNoteData = {
    id:number|null;
    category_id:number|null;
    company_id:number|null;
    title:string|null;
    type_of_note:string;
    description:string;
    createdAt:Date|null;
    updatedAt:Date|null;
    created_by_user_id:number |null;
    updated_by_user_id:number |null;
    creatingUser: UserData;
    updatingUser: UserData;
    contacts: Contact[] | undefined;

}